import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ButtonIcon } from '../appearence/icons/button_icon';
import { LogoIcon } from '../appearence/icons/logo_icon';
import { errorCallback, makeUrl, RECAPTCHA_SITE_KEY } from "../constant";
import { LOGIN_REQUEST, postFetchRequest } from '../store/requests';

const LoginPage = ({ setIsAuthenticated }) => {
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [captchaToken, setCaptchaToken] = useState('');
    const [captchaReady, setCaptchaReady] = useState(false);
    const captchaRef = useRef(null);
    const widgetIdRef = useRef(null);

    const succesLoginCallback = (response) => {
        if(response && response.status === 'ok') {
            setIsAuthenticated(true);
            navigate("/");
        }
    };

    useEffect(() => {
        const scriptId = 'recaptcha-script';
        if (document.getElementById(scriptId)) {
            setCaptchaReady(true);
            return;
        }
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://www.google.com/recaptcha/api.js?onload=__recaptchaOnLoad&render=explicit';
        script.async = true;
        script.defer = true;
        window.__recaptchaOnLoad = () => {
            setCaptchaReady(true);
        };
        document.body.appendChild(script);
    }, []);

    useEffect(() => {
        if (captchaReady && window.grecaptcha && captchaRef.current && widgetIdRef.current === null) {
            widgetIdRef.current = window.grecaptcha.render(captchaRef.current, {
                sitekey: RECAPTCHA_SITE_KEY,
                callback: (token) => setCaptchaToken(token),
                'error-callback': () => setCaptchaToken(''),
                'expired-callback': () => setCaptchaToken(''),
            });
        }
    }, [captchaReady]);

    const handleLogin = () => {
        if(login && password && captchaToken) {
            const data = {login, password, captchaToken};
            postFetchRequest(makeUrl([LOGIN_REQUEST]), data, succesLoginCallback, errorCallback);
        }
    };

    const handleKeyDown = (e) => {
        if(e.keyCode === 13) {
                handleLogin();
        }
    };

    return (
        <>
            <header className="login-header">
                <LogoIcon />
            </header>
            <main className="login-main" onKeyDown={handleKeyDown}>
                <div className="login-card">
                    <label className="login-card__label login-card__label">Введите e-mail для входа:</label>
                    <input
                        className="login-card__input"
                        value={login}
                        onChange={(e)=> setLogin(e.target.value.trim())}
                    />
                    <label className="login-card__label">Пароль:</label>
                    <input
                        type="password"
                        className="login-card__input"
                        value={password}
                        onChange={(e)=> setPassword(e.target.value.trim())}
                    />
                    <div
                        ref={captchaRef}
                        className="g-recaptcha"
                        style={{ marginTop: '12px', marginBottom: '12px' }}
                    />
                    <button className="button login-main__button" onClick={handleLogin} disabled={!captchaToken}>
                        <span className="button__text">Войти </span>
                        <ButtonIcon />
                    </button>
                </div>
            </main>
        </>
    );
};

export default LoginPage;